import { PRIVATE_MODULES_PATH } from "./root.path";

export const PATH_ROUTER_REPORT = {
  LIST: "/",
  CREATE: "create",
  EDIT: "edit",
  DETAIL: "detail"
};

const BASE = PRIVATE_MODULES_PATH.REPORT;
const { CREATE, DETAIL, EDIT, LIST } = PATH_ROUTER_REPORT;

export const PATH_ROUTES_REPORT = {
  LIST: `/${BASE}/${LIST}`
  // CREATE: `/${BASE}/${CREATE}`,
  // EDIT: (id: number) => `/${BASE}/${EDIT}/${id}`,
  // DETAIL: (id: number) => `/${BASE}/${DETAIL}/${id}`,
};
